import React, { useEffect } from 'react';
import { analyticsPageName, t } from '../../../../shared/onboardingUtils';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import ModalBodyWithAlerts from '../../../ModalBodyWithAlerts';
import OnboardingModalActions from '../../../OnboardingModalActions';

import gdprHealthIcon from './images/icon-gdpr-health.svg';

import styles from './Health.scss';
import HeaderIcon from '../../../HeaderIcon';
import OnboardingLinkButton from '../../../OnboardingLinkButton';
import PERMISSION_TYPES from '../../../../../../constants/consents/permissionTypes';
import { CONSENTS_FLOW } from '../../../../shared/onboardingConstants';

const Health = () => {
  const { state, dispatch, track } = useOnboardingContext();
  const { alert, locale } = state;

  useEffect(() => {
    track({
      page: analyticsPageName(CONSENTS_FLOW.health),
      action: 'screen_enter'
    });
  }, [track]);

  const { stepForward, isProcessing, elementName } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });

  return (
    <>
      <ModalBodyWithAlerts alert={alert}>
        <HeaderIcon source={gdprHealthIcon} />
        <h2>{t('consents.health.header')}</h2>
        <p>{t('consents.health.description_html')}</p>
        <OnboardingLinkButton
          href={`https://support.strava.com/hc/${locale.toLowerCase()}/articles/360000556410`}
        >
          {t('consents.health.learn_more')}
        </OnboardingLinkButton>
      </ModalBodyWithAlerts>
      <OnboardingModalActions>
        <ActionButton
          variant="default"
          onClick={() => stepForward({ action: ACTIONS.decline })}
          data-cy="health-decline-next-step-btn"
          isProcessing={isProcessing && elementName === ACTIONS.decline}
          isDisabled={isProcessing}
          className={styles.actionButton}
        >
          {t('cta_actions.decline')}
        </ActionButton>
        <ActionButton
          variant="primary"
          onClick={() =>
            stepForward({
              action: ACTIONS.approved,
              permissionType: PERMISSION_TYPES.health
            })
          }
          data-cy="health-allow-next-step-btn"
          isProcessing={isProcessing && elementName === ACTIONS.approved}
          isDisabled={isProcessing}
          focus={true}
          className={styles.actionButton}
        >
          {t('cta_actions.allow')}
        </ActionButton>
      </OnboardingModalActions>
    </>
  );
};

export default Health;
